// // 本地测试
// export const HOST = 'http://localhost'
// export const PORT = ':3002'

import { LOCAL_TEST } from "./Macro"

// 远程服务器
export const HOST = LOCAL_TEST ? 'http://localhost' : 'https://ctrl.healthassistant.app'
export const PORT = LOCAL_TEST ? ':3002' : ''

export const ROOT = `/mgmt`
// export const ROOT = `/`

export const URL = `${HOST}${PORT}`

export const FilePath = {
    REPORTS: `${URL}/files/reports/`,
    RECORDS: `${URL}/files/records/`,
    LOGS: `${URL}/files/client_logs/`,
    CSV: `${URL}/files/ecg/`,
}

export const AuthApi = {
    SEND_PIN: `${URL}/admin/auth/sendPin`,
    RESET_PWD: `${URL}/admin/auth/resetPwd`,
    CHECK_LOGIN: `${URL}/admin/auth/checkLogin`,
    SUPER_LOGIN: `${URL}/admin/auth/super/login`,
    /** 普通用户登录 */
    USER_LOGIN: `${URL}/admin/auth/user/login`,

    /** 加密测试 */
    ENCODE_TEST: '/admin/auth/test/encode',
    DECODE_TEST: '/admin/auth/test/decode',

    /** 用户下线 */
    LOGOUT: '/admin/auth/logout',
}

/** 基于日期查询的接口(canlendar). */
export const CalendarApi = {
    /** 查询指定日期记录列表(概述)的接口 */
    GET_RECORD_LIST_BY_DATE: `${URL}/admin/calendar/getRecordListByDate`,
    /** 查询指定时间段记录列表(概述)的接口(给出开始时间和结束时间) */
    GET_RECORD_LIST_BY_TIME_INTERVAL: `${URL}/admin/calendar/getRecordListByTimeInterval`,
}

export const UserMgmtApi = {
    /** 超级管理员获取账号列表 */
    SUPER_GET_ACCOUNT_LIST: `${URL}/admin/userMgmt/super/getAccountList`,

    /** 超级管理员获取账号详情 */
    SUPER_GET_ACCOUNT_DETAIL: `${URL}/admin/userMgmt/super/getAccountDetail`,

    /** 超级管理员获取账号详情(获取新记录列表) */
    SUPER_GET_ACCOUNT_DETAIL_2: `${URL}/admin/userMgmt/super/getAccountDetail2`,

    /** 超级管理员获取使用者列表 */
    SUPER_GET_USER_LIST: `${URL}/admin/userMgmt/super/getUserList`,

    /** 超级管理员获取记录列表 */
    SUPER_GET_RECORD_LIST: `${URL}/admin/userMgmt/super/getRecordList`,

    /** 超级管理员获取记录列表(获取新记录列表) */
    SUPER_GET_RECORD_LIST_2: `${URL}/admin/userMgmt/super/getRecordList2`,

    /** 超级管理员获取日志列表 */
    SUPER_GET_LOG_LIST: `${URL}/admin/userMgmt/super/getLogList`,

    /** 超级管理员删除记录 */
    SUPER_DEL_RECORD: `${URL}/admin/userMgmt/super/delRecord`,

    /** 批量删除日志(仅管理员可以操作) */
    SUPER_DEL_LOGS: `${URL}/admin/userMgmt/super/delLogs`,

    /** 普通用户获取账户信息 */
    USER_GET_ACCOUNT_DETAIL: `${URL}/admin/userMgmt/user/getAccountDetail`,

    /** 普通用户获取账户信息(获取新记录列表) */
    USER_GET_ACCOUNT_DETAIL_2: `${URL}/admin/userMgmt/user/getAccountDetail2`,

    /** 普通用户获取记录列表 */
    USER_GET_RECORD_LIST: `${URL}/admin/userMgmt/user/getRecordList`,

    /** 普通用户获取日志列表 */
    USER_GET_LOG_LIST: `${URL}/admin/userMgmt/user/getLogList`,

    // 通用接口
    /** 获取操作日志列表 */
    GET_OP_LOG_LIST: `/admin/userMgmt/user/getOpLogList`,
}

export const FirmwareApi = {
    SUPER_UPGRADE: `${URL}/admin/firmware/super/upgrade`,
    SUPER_DIRECTORY: `${URL}/admin/firmware/super/directory`,
}

export const AppApi = {
    SUPER_UPGRADE: `${URL}/admin/app/super/upgrade`,
    SUPER_DIRECTORY: `${URL}/admin/app/super/directory`,
    SUPER_UPGRADE_PC: `${URL}/admin/app/super/upgradePc`,
    SUPER_UPGRADE_IOS: `${URL}/admin/app/super/upgradeIos`,
    SUPER_UPGRADE_IOS_TEST: `${URL}/admin/app/super/upgradeIosTest`,
}

export const FileApi = {
    SUPER_DEL: `${URL}/admin/file/super/del`,
}

/** 数据管理接口(data). */
export const DataApi = {
    /** 获取记录的图表数据 */
    GET_RECORD_CHART: `${URL}/admin/data/getRecordChart`,
    /** 获取心电图的相关信息 */
    GET_RECORD_INFO: `${URL}/admin/data/getRecordInfo`,
    /** 获取HRV数据 */
    GET_HRV: '/admin/data/getHrv',
    /** 获取HRV解析进度和按分页获取HRV数据 */
    GET_HRV_PAGE: '/admin/data/getHrvPage',
    /** 如果没有开始解析，则开启解析线程，如果已经开始，则显示解析进度 */
    DECODE_ECG: '/admin/data/decodeEcg',
    /** 删除CSV文件 */
    DEL_CSV: `${URL}/admin/data/delCsv`,
    /** 删除指定时间之前的CSV文件. */
    DEL_CSV_BEFORE: `${URL}/admin/data/delCsvBefore`,
    /** 删除指定时间之前的日志文件. */
    DEL_LOG_BEFORE: `${URL}/admin/data/delLogBefore`,
}

export const SystemApi = {
    /** 获取服务器系统信息 */
    GET_SYSTEM_INFO: '/admin/sys/getSystemInfo',
    /** 获取签名过期时间 */
    GET_CERT_EXPIRE_TIME: `${URL}/admin/sys/getCertExpireTime`,
    /** 获取CPU使用状况 */
    GET_CPU_STATUS: `/admin/sys/getCpuStatus`,
    /** 获取硬盘(Hard Disk)使用状况 */
    GET_HD_STATUS: `/admin/sys/getHdStatus`,
    /** 获取用户(User)信息 */
    GET_USER_STATUS: `/admin/sys/getUserStatus`,
}

/** 统计接口(stats). */
export const StatsApi = {
    /** 获取日志的统计信息 */
    GET_LOG_INFO: '/admin/stats/getLogInfo',
    /** 获取记录的统计信息 */
    GET_RECORD_INFO: '/admin/stats/getRecordInfo',
}

/** 推送管理接口(push). */
export const PushApi = {
    /** 获取活跃推送记录列表 */
    GET_ACTIVE_PUSH_LIST: '/admin/push/getActivePushList',
    /** 获取历史推送记录列表 */
    GET_HISTORY_PUSH_LIST: '/admin/push/getHistoryPushList',
}

/** SDK管理接口(sdk). */
export const SdkApi = {
    /** 注册账户 */
    REGISTER_ACCOUNT: `${URL}/admin/sdk/register_user`,
    /** 应用(APP)申请接口 */
    INIT_APP: `${URL}/admin/sdk/init_app`,
    /** 应用管理后台登录接口(登录后返回应用的相关信息: APPKey, AppSecret, RemainTimes) */
    LOGIN_ACCOUNT: `${URL}/admin/sdk/login_app`,
    /** 获取当前账号下的所有应用列表 */
    GET_APP_LIST: `${URL}/admin/sdk/get_app_list`,
    /** 获取SDK调用日志 */
    GET_LOG_LIST: `${URL}/admin/sdk/get_log_list`,
    /** 获取指定应用的详情 */
    GET_APP_DETAIL: `${URL}/admin/sdk/get_app_detail`,
    /** 应用信息查询接口(可用于定时刷新页面) */
    QUERY_APP: `${URL}/admin/sdk/query_app`,
    /** 调用次数购买接口 */
    BUY_TIMES: `${URL}/admin/sdk/buy_times`,
    /** 开关应用 */
    CHANGE_APP_STATUS: `${URL}/admin/sdk/change_app_status`,
    /** 删除应用 */
    DEL_APP: `${URL}/admin/sdk/del_app`,
    /** 上传SDK使用文档 */
    UPLOAD_DOC: `${URL}/admin/sdk/upload_doc`,
    /** 上传SDK文件 */
    UPLOAD_SDK: `${URL}/admin/sdk/upload_sdk`,
    /** 获取文档的下载信息 */
    GET_DOWNLOAD_INFO: `${URL}/admin/sdk/get_download_info`,
    /** 更新应用信息(过期时间，可用次数) */
    UPDATE_APP: `${URL}/admin/sdk/update_app`,

    /** 获取客户端调试日志 */
    GET_CLIENT_LOGS: `${URL}/admin/sdk/getClientLogs`,
    /** 删除SDK日志 */
    DEL_SDK_LOG: `${URL}/admin/sdk/delSdkLog`,
    /** 删除SDK过期的使用记录 */
    DEL_SDK_USAGE_RECORD_BEFORE: `${URL}/admin/sdk/delSdkUsageRecordBefore`,
}

/** DRP管理接口(drp). */
export const DrpApi = {
    /** 获取任务列表(EDF分析任务) */
    GET_TASK_LIST: `${URL}/admin/sdk/getTaskList`,
    /** 获取任务详情(EDF分析任务) */
    GET_TASK_DETAIL: `${URL}/admin/sdk/getTaskDetail`,
}